import styled, { css } from 'styled-components';
import { mq } from 'stylesheets/utils';

export const Label = styled.label`
  font-size: ${({ theme }) => theme.fontsizes.h6};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.black2};
  margin-right: 72px;
  white-space: nowrap;
  min-width: 134px;
  ${mq(768)} {
    min-width: 110px;
  }
  ${mq(576)} {
    margin-bottom: 8px;
  }
`;

export const InputWrapper = styled.div`
  max-width: 567px;
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  position: relative;
  border: 1px solid ${({ theme }) => theme.colors.auth.lightPurple};
  border-radius: 4px;
  padding: 0 16px 0 30px;
  input {
    border: none;
  }
`;

export const Input = styled.input`
  font-size: ${({ theme }) => theme.fontsizes.body16};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.black2};
  border: none;
  width: 100%;
`;

export const Error = styled.p`
  position: absolute;
  left: 0;
  bottom: 0;
  transform: translateY(120%);
  font-size: ${({ theme }) => theme.fontsizes.body12};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
  color: ${({ theme }) => theme.colors.brandColor};
`;

export const FieldWrapper = styled.div<{
  readonly vertical?: boolean;
  readonly small?: boolean;
}>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  max-width: 776px;
  align-items: center;
  margin-bottom: 34px;
  ${mq(576)} {
    flex-direction: column;
    align-items: flex-start;
  }
  ${({ vertical }) =>
    vertical
      ? css`
          flex-direction: column;
        `
      : css``}
  ${({ small }) =>
    small
      ? css`
          margin-bottom: 20px;
          align-items: flex-start;
          ${Label} {
            font-size: ${({ theme }) => theme.fontsizes.body16};
            font-weight: ${({ theme }) => theme.fontWeight.font400};
            color: ${({ theme }) => theme.colors.lightPurple};
            padding: 0 14px;
            margin-bottom: 12px;
          }
        `
      : css``}
`;
